/** Converts a #rrggbb hex color to the "H S% L%" format Tailwind's CSS variables
 * use here (no hsl() wrapper - see index.css). Returns null for anything that
 * isn't a valid 6-digit hex color. */
export function hexToHslString(hex: string): string | null {
  const match = /^#([0-9a-fA-F]{6})$/.exec(hex);
  if (!match) return null;

  const r = parseInt(match[1].slice(0, 2), 16) / 255;
  const g = parseInt(match[1].slice(2, 4), 16) / 255;
  const b = parseInt(match[1].slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;

  if (max === min) return `0 0% ${Math.round(l * 100)}%`;

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h: number;
  switch (max) {
    case r:
      h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
      break;
    case g:
      h = ((b - r) / d + 2) / 6;
      break;
    default:
      h = ((r - g) / d + 4) / 6;
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

   /** The text colour (as the "H S% L%" triplet the CSS variables use) that reads best ON this #rrggbb accent:
    *  white when white gets at least 3:1 contrast (large bold text, WCAG AA), otherwise near-black. Null for a bad hex. */
   export function foregroundHslFor(hex: string): string | null {
     const m = /^#([0-9a-fA-F]{6})$/.exec(hex);
     if (!m) return null;
     const c = [0, 2, 4].map((i) => parseInt(m[1].slice(i, i + 2), 16) / 255).map((v) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)));
     const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
     return 1.05 / (L + 0.05) >= 3 ? "0 0% 100%" : "0 0% 6.7%";
   }
   